export default __webpack_public_path__ + "static/media/star.16d8c811.svg";